<template>
    <div class="d-flex align-items-center mb-2">
        <span class="me-1 ms-auto">
            <span class="badge badge-pill badge-app-primary"> New </span>
        </span>
        <a href="https://www.cdc.gov/coronavirus/2019-ncov/index.html" rel="noopener noreferrer" target="_blank">
            COVID-19: CDC Coding Guidance
        </a>
        <button class="btn btn-primary btn-xs ms-2" @click="addDiagnosis()">Add Diagnosis</button>
    </div>
    <Pagination
        ref="paginationInstance"
        :page-changed="pageChangedCallback"
        :is-loading="isLoading"
        :page-size="pageLimit"
        :show-page-size-options="false"
    >
        <table class="table table-responsive-md border border-gray overflow-auto">
            <thead>
                <tr class="bg-table-header">
                    <th>ICD-10 Code</th>
                    <th>Description</th>
                    <th>Start Date</th>
                    <th>Resolution Date</th>
                    <th class="text-end">Actions</th>
                </tr>
            </thead>
            <!--Empty Table-->
            <tbody>
                <TableEmpty
                    v-if="diagnosis?.length === 0 && newDiagnosis?.length === 0"
                    :col-span="columns"
                    component="diagnoses"
                    secondary-message="No Diagnoses to Display"
                />
                <!-- Existing Diagnoses -->
                <PastDiagnosisRow
                    v-for="(diag, index) of diagnosis"
                    :diag="diag"
                    v-on:cancelEditDiagChanges="cancelEditDiagChanges"
                    :delete-diagnosis="deleteDiagnosis"
                    :move-diagnosis-up="moveDiagnosis"
                    :move-diagnosis-down="moveDiagnosis"
                    :first="index === 0"
                    :last="index === diagnosis.length - 1"
                    :index="index"
                    current-view="edit"
                />
                <!-- New Diagnoses -->
                <PastDiagnosisRow
                    v-show="newDiagnosis.length > 0"
                    v-for="(diag, index) of newDiagnosis"
                    :key="diag.id"
                    :diag="diag"
                    :is-add-requested="isAddRequested"
                    :save-new-diagnosis="saveNewDiagnosis"
                    :cancel-save-new-diagnosis="cancelSaveNewDiagnosis"
                    :is-new-terminal="isNewTerminal"
                    :index="index"
                    current-view="add"
                />
            </tbody>
        </table>
    </Pagination>
</template>

<script lang="ts" src="./PastDiagnosisHistory.ts" />
